module.exports = {"330303001":"永中街道","330303002":"蒲州街道","330303003":"海滨街道","330303004":"永兴街道","330303006":"状元街道","330303007":"瑶溪街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330303.json
// module id = 890
// module chunks = 0